enum DropDownValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}

export { DropDownValidations };
